import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { mutateConfig } from '../api/queryBase';
import { AxiosError } from 'axios';
import { getErrorMessage, validateEmail } from '../utils/helper';
import { loginUser, logoutUser } from '../store/userSlice/userSlice';
import { Alert } from 'antd';
import jwt_decode from 'jwt-decode';
import Input from '../components/input/Input';
import Button from '../components/button/Button';

const Login = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const mutation = mutateConfig();
    const { mutate } = mutation({
        url: '/login'
    });

    const [loading, setLoading] = useState(false);
    const [payload, setPayload] = useState<any>({
        username: undefined,
        userSecret: undefined
    });
    const [errors, setErrors] = useState({
        username: '',
        userSecret: ''
    });
    const [error, setError] = useState<string | any>(null);

    const updateField = (name: string, value: any) => {
        setPayload((prevState: any) => ({
            ...prevState,
            [name]: value
        }));
    };

    const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        setErrors((prevState: any) => ({
            ...prevState,
            username: '',
            userSecret: ''
        }));

        mutate(payload, {
            onSettled: (res, error: AxiosError | undefined | any) => {
                setLoading(false);
                if (error) {
                    setError(
                        getErrorMessage(error) ||
                            'An error has occured. Please try again.'
                    );
                } else {
                    const { access_token, refresh_token } = res?.payload as {
                        access_token: string;
                        refresh_token: string;
                    };

                    const user: any = jwt_decode(access_token);

                    localStorage.setItem('token', access_token);
                    localStorage.setItem('refreshToken', refresh_token);
                    localStorage.setItem('exp', user.exp);

                    dispatch(
                        loginUser({
                            token: access_token,
                            user,
                            refresh: refresh_token
                        })
                    );
                    navigate('/dashboard');
                }
            }
        });
    };

    useEffect(() => {
        if (payload !== null) {
            setErrors((prevState) => ({
                ...prevState,
                username:
                    payload?.username === undefined
                        ? ''
                        : validateEmail(payload?.username)
                        ? ''
                        : 'Invalid email address',
                userSecret:
                    payload?.userSecret === undefined
                        ? ''
                        : payload?.userSecret.length > 0
                        ? ''
                        : 'Password is required'
            }));
        }
    }, [payload]);

    useEffect(() => {
        dispatch(logoutUser());
    }, [dispatch]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setPayload({
            ...payload,
            [name]: value
        });
    };

    return (
        <div>
            <div className='bg-appcolorwhite py-[2.7rem] lg:py-[2.5rem] lg:px-[2.6rem] px-[1.6rem] mb-[1.75rem] rounded-[3px]'>
                {error !== null && (
                    <Alert
                        type='error'
                        message={error ?? 'Something went wrong'}
                        banner
                        className='text-red-700 text-left rounded-md mb-2'
                    />
                )}

                <form autoComplete='off' onSubmit={onSubmit} noValidate>
                    <div className='flex flex-col gap-4 lg:gap-[4] text-left'>
                        <Input
                            label='Email'
                            type='email'
                            errorMessage={
                                errors?.username.length > 0
                                    ? errors?.username
                                    : undefined
                            }
                            isError={errors?.username.length > 0}
                            required
                            id='signin-email'
                            name='username'
                            onChange={handleInputChange}
                            placeholder='bayomi@frontedge.io'
                        />

                        <Input
                            label='Password'
                            type='password'
                            errorMessage={
                                errors?.userSecret.length > 0
                                    ? errors?.userSecret
                                    : undefined
                            }
                            isError={errors?.userSecret.length > 0}
                            required
                            id='signin-email'
                            name='userSecret'
                            onChange={(e) => {
                                updateField('userSecret', e.target.value);
                            }}
                        />
                    </div>

                    <p className='mt-4 text-[13px] text-appcolorprimary leading-[16px] text-left'>
                        <span
                            className='cursor-pointer'
                            onClick={() => {
                                navigate('/password/forgot');
                            }}
                        >
                            Forgot Password?
                        </span>
                    </p>

                    <div className='mt-4'>
                        <Button
                            isLoading={loading}
                            type='submit'
                            className='w-full'
                            disabled={
                                Object.values(payload).some(
                                    (item: any) => item === undefined
                                ) ||
                                Object.values(errors).some(
                                    (item) => item.length > 0
                                ) ||
                                loading
                            }
                            text='Continue'
                        />
                    </div>
                </form>

                <p className='mt-4 text-sm text-appcolorfaint leading-[18px] text-left'>
                    Dont't have an account?{' '}
                    <span
                        className='underline cursor-pointer text-appcolorprimary'
                        onClick={() => {
                            navigate('/signup');
                        }}
                    >
                        Sign Up
                    </span>
                </p>
            </div>
        </div>
    );
};

export default Login;
